import { forwardRef, Ref, type SVGProps } from 'react';

const SvgArrowUpRightIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7 17 17 7m0 10V7H7"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgArrowUpRightIcon);
export default ForwardRef;
